import { Flex, Typography } from "antd";
import { FC } from "react";

import { BaseModal } from "@/shared/ui/BaseModal";

interface RemainingsWarningModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    productName: string;
    input?: number | null;
    left: number;
}

export const RemainingsWarningModal: FC<RemainingsWarningModalProps> = ({
    open,
    onClose,
    onConfirm,
    productName,
    input,
    left,
}) => {
    const handleConfirm = async () => {
        onConfirm();
    };

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            onConfirm={handleConfirm}
            title="Перевищено залишок товару"
            description="Ви ввели кількість, що перевищує доступний залишок на складі."
            confirmText="Ігнорувати залишки"
            cancelText="Повернутися назад"
        >
            <Flex vertical gap={4}>
                <Typography>Товар: {productName}</Typography>
                <Typography>Доступно на складі: {left}</Typography>
                <Typography>Введено: {input}</Typography>
            </Flex>
        </BaseModal>
    );
};
